// Image array for carousel - relative paths work in theme assets
const productImages = [
  'Shop_Image.webp',
  'Product_Image_2.webp',
  'Product_Image_3.webp',
  'Product_Image_4.webp',
  'Product_Image_5.webp',
  'Product_Image_6.webp'
];

const imageIndices = {
  '': 0,
  'home': 0,
  'faq': 0,
  'maintenance': 0,
  'recycling': 0
};

function changeImageByArrow(direction, section = '') {
  const imageId = section ? `mainImage-${section}` : 'mainImage';
  const mainImage = document.getElementById(imageId);
  
  if (!mainImage) return;
  
  // Get the current image URL to extract the base path
  let currentSrc = mainImage.src;
  let basePath = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
  
  imageIndices[section] = (imageIndices[section] || 0) + direction;
  
  if (imageIndices[section] < 0) {
    imageIndices[section] = productImages.length - 1;
  }
  if (imageIndices[section] >= productImages.length) {
    imageIndices[section] = 0;
  }
  
  mainImage.src = basePath + productImages[imageIndices[section]];
  mainImage.style.opacity = '0.8';
  setTimeout(() => {
    mainImage.style.opacity = '1';
  }, 100);
}
